import client from './client';

export interface Company {
  id: string;
  name: string;
  legalName: string | null;
  registrationNumber: string | null;
  taxId: string | null;
  jurisdiction: 'UK' | 'EE' | 'DE' | 'US' | 'ZM';
  countryCode: string;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  logoUrl: string | null;
  baseCurrency: string;
  fiscalYearEnd: string | null;
  createdAt: string;
  updatedAt: string;
  userRole?: string;
}

export interface CreateCompanyPayload {
  name: string;
  legalName?: string;
  registrationNumber?: string;
  taxId?: string;
  jurisdiction: 'UK' | 'EE' | 'DE' | 'US' | 'ZM';
  countryCode?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  baseCurrency?: string;
  fiscalYearEnd?: string;
}

export interface UpdateCompanyPayload {
  name?: string;
  legalName?: string;
  registrationNumber?: string;
  taxId?: string;
  jurisdiction?: 'UK' | 'EE' | 'DE' | 'US' | 'ZM';
  countryCode?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  logoUrl?: string;
  baseCurrency?: string;
  fiscalYearEnd?: string;
}

export const fetchCompanies = async (): Promise<Company[]> => {
  const response = await client.get<Company[]>('/companies');
  return response.data;
};

export const fetchCompany = async (id: string): Promise<Company> => {
  const response = await client.get<Company>(`/companies/${id}`);
  return response.data;
};

export const createCompany = async (payload: CreateCompanyPayload): Promise<Company> => {
  const response = await client.post<Company>('/companies', payload);
  return response.data;
};

export const updateCompany = async (id: string, payload: UpdateCompanyPayload): Promise<Company> => {
  const response = await client.put<Company>(`/companies/${id}`, payload);
  return response.data;
};

export const deleteCompany = async (id: string): Promise<void> => {
  await client.delete(`/companies/${id}`);
};

export const uploadLogo = async (companyId: string, file: string, filename: string): Promise<{ logoUrl: string }> => {
  const response = await client.post<{ logoUrl: string }>(`/companies/${companyId}/logo`, {
    file,
    filename
  });
  return response.data;
};

export const deleteLogo = async (companyId: string): Promise<void> => {
  await client.delete(`/companies/${companyId}/logo`);
};
